var _path, _path2, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon02Calls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 6.7h-2.1V5.2c0-1.1-.9-2-2-2h-1.1c-1.1 0-2 .9-2 2v1.5h-8.3V5.2c0-1.1-.9-2-2-2H9.3c-1.1 0-2 .9-2 2v1.5H5.2c-1.1 0-2 .9-2 2v19.2c0 1.1.9 2 2 2h22.7c1.1 0 2-.9 2-2V8.7c0-1.1-.9-2-2-2zm-5.7-1.5c0-.3.2-.5.5-.5h1.1c.3 0 .5.2.5.5v4.5c0 .3-.2.5-.5.5h-1.1c-.3 0-.5-.2-.5-.5V5.2zm-13.4 0c0-.3.2-.5.5-.5h1.1c.3 0 .5.2.5.5v4.5c0 .3-.2.5-.5.5H9.3c-.3 0-.5-.2-.5-.5V5.2zm19.6 22.7c0 .3-.2.5-.5.5H5.2c-.3 0-.5-.2-.5-.5V8.7c0-.3.2-.5.5-.5h2.1v1.5c0 1.1.9 2 2 2h1.1c1.1 0 2-.9 2-2V8.2h8.3v1.5c0 1.1.9 2 2 2h1.1c1.1 0 2-.9 2-2V8.2h2.1c.3 0 .5.2.5.5v19.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 14.9H11.9c-.4 0-.8.3-.8.8s.3.8.8.8h13.2c.4 0 .8-.3.8-.8s-.4-.8-.8-.8zM25.1 18.9H11.9c-.4 0-.8.3-.8.8s.3.8.8.8h13.2c.4 0 .8-.3.8-.8s-.4-.8-.8-.8zM25.1 22.9H11.9c-.4 0-.8.3-.8.8s.3.8.8.8h13.2c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6,
    cy: 15.7,
    r: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6,
    cy: 19.7,
    r: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6,
    cy: 23.7,
    r: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon02Calls);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_02_Calls.f9e220e3.svg";
export { ForwardRef as ReactComponent };